import React from 'react';

import { TableCell, TableRow } from '@mui/material';

export const HEADER_COLUMN_SPAN = 14;

export function SearchHotelHead() {
  return (
    <TableRow>
      <TableCell colSpan={2} sx={{ minWidth: 150 }}>
        Global Rank
      </TableCell>
      <TableCell align="right">Type</TableCell>
      <TableCell sx={{ minWidth: 150 }} align="right">
        List Visibility Schedule
      </TableCell>
      <TableCell align="right">Views</TableCell>
      <TableCell align="right">Sales #</TableCell>
      <TableCell align="right">Sales $</TableCell>
      <TableCell align="right">Margin #</TableCell>
      <TableCell align="right">Margin %</TableCell>
      <TableCell align="right">Margin / View</TableCell>
      <TableCell align="right">Adjusted MPV</TableCell>
      <TableCell align="right">Manual Score</TableCell>
      <TableCell align="right">CTR</TableCell>
      <TableCell align="right">Final Score</TableCell>
    </TableRow>
  );
}
